/**
 * Created by andreyna on 1/26/2017.
 */
const MEMBERSHIP_POST_ACTIONS = {
    PLAY: '1',
    DEPOSIT: '2',
    BACK: '3',
    UPLOAD_DOCUMENTS_CASHIER: '7',
    REGISTRATION_COMPLETED: '8',
    OPEN_BANK_ID: '64',
    DOWNLOAD_APP: '68',
    STORE_REGISTRATION_COOKIES_DATA:'69',
    SHOW_LOGIN: '73',
    UPLOAD_DOCUMENTS_IV: '75'
};

const REGISTRATION_DATA_KEY = 'storeRegistrationData';

export {MEMBERSHIP_POST_ACTIONS, REGISTRATION_DATA_KEY};